import { styled } from "styled-components";

export const DropdownContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px;
  width: 200px;
  ${({ theme }) => theme.breakpoints.sm.query} {
    width: revert;
  }
`;
